import { render, staticRenderFns } from "./internshipdetails.vue?vue&type=template&id=22cee057&scoped=true&"
import script from "./internshipdetails.vue?vue&type=script&lang=js&"
export * from "./internshipdetails.vue?vue&type=script&lang=js&"
import style0 from "./internshipdetails.vue?vue&type=style&index=0&id=22cee057&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cee057",
  null
  
)

export default component.exports